<template>
  <div class="home-widgets">
    <HomeSkeleton v-if="isLoading" class="home-widgets__skeleton" />

    <div class="home-widgets__items">
      <TypeWidgets
        v-for="(widget, i) in sections"
        :key="widget.modelId + widget.modelType"
        :index="i"
        :widget="widget"
      >
        <CategoriesSection v-if="i === 2" />
      </TypeWidgets>
    </div>
  </div>
</template>

<script>
import TypeWidgets from '~/components/Lobby/TypeWidgets'
import HomeSkeleton from '~/components/Home/DynamicWidgets/Skeleton'
const CategoriesSection = () => import('@/components/Home/CategoriesSection')
import { MODEL_TYPE } from '@/components/Lobby/enum'
import PromotionsMapper from '@/components/shared/Cards/CardPromotionPreview/mapper'

export default {
  name: 'DynamicWidgets',
  static: {
    TERM: 'main',
  },
  components: {
    TypeWidgets,
    CategoriesSection,
    HomeSkeleton,
  },
  data() {
    return {
      sections: [],
      isLoading: true,
    }
  },
  async fetch() {
    this.isLoading = true
    try {
      this.sections = await this.getSections()
    }
    catch (error) {
    }
    this.isLoading = false
  },
  methods: {
    async getSections() {
      const { data } = await this.$api._games.getSectionViewLayout({ term: this.$options.static.TERM })

      const widgetIdx = data.layout.findIndex(widget => widget.modelType === MODEL_TYPE.PROMOTIONS)
      if (widgetIdx === -1) return data.layout

      const banners = data.layout[widgetIdx].promotionBanners.map(PromotionsMapper.fromWidgetToCard)
      data.layout[widgetIdx].promotionBanners = banners
      return data.layout
    },
  },
}
</script>
<style lang="scss" scoped>
.home-widgets {
  &__items {
    ::v-deep > div:not(:last-child) > * {
      margin-bottom: var(--spaces-2xl);

      @include media(tablet) {
        margin-bottom: var(--spaces-3xl);
      }
    }
  }
}
</style>
